export default __webpack_public_path__ + "static/media/peas.81ed40e7.png";